import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, DatePicker } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { connect } from 'react-redux';
import { RevisionService } from 'services';
import { UploadIcon, CloseIcon, StarIcon } from 'assets/icons';
import { WhiteImage } from 'assets/img';

interface Props extends RootState {
  onClose?: any;
  item?: any;
}

class ModalUpload extends React.Component<Props> {
  state = {
    form: {
      file: '',
    },
    average: null,
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await RevisionService.view({
      revision_id: this.props.item?.id,
    });
    this.setState({
      average: res.average || null,
    });
  };

  submit = async () => {
    const { file } = this.state.form;

    if (!file) {
      Globals.showError('Por favor, suba el documento para continuar');
      return;
    }

    const res: any = await RevisionService.uploadDocument({
      hasFile: true,
      revision_id: this.props.item?.id,
      // @ts-ignore
      file: this.state.form.file?.value,
    });
    this.props.onClose();
    Globals.showSuccess('Se ha enviado su documento');
  };

  render() {
    const item: any = this.props.item;

    return (
      <div id='modal-upload-document'>
        {item != null && (
          <>
            {item.lawyer && (
              <div className='container-lawyer'>
                <img
                  src={
                    item?.lawyer?.photo ? Constants.BASE_STORAGE + item?.lawyer?.photo : WhiteImage
                  }
                  className='image-principal'
                />
                <div style={{ flex: 1 }}>
                  <p className='name'>{item?.lawyer?.full_name}</p>
                  <p>Abogado</p>
                </div>
                {this.state.average != null && (
                  <div className='container-star'>
                    <p>{this.state.average}</p>
                    <img src={StarIcon} />
                  </div>
                )}
              </div>
            )}
            <p className='area-name'>{item?.area?.name}</p>
            <p className='document-name'>{item?.document?.name}</p>
            <div className='container-white'>
              {this.state.form.file == '' && (
                <div className='file-container'>
                  <div className='container-icon'>
                    <img src={UploadIcon} />
                    <p>Subir documento (PDF, Word, Excel o PowerPoint)</p>
                  </div>
                  <PaperClip
                    formats={['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']}
                    successText='Subir documento'
                    pendingText='Subir documento'
                    value={this.state.form.file}
                    onChange={(e: any) => {
                      this.setState({
                        form: {
                          ...this.state.form,
                          file: e.target,
                        },
                      });
                    }}
                  />
                </div>
              )}
              {this.state.form.file != '' && (
                <>
                  <div className='file-uploaded'>
                    <img src={UploadIcon} />
                    <p>Documento</p>
                    <button
                      className='btn'
                      onClick={() => {
                        this.setState({
                          form: {
                            ...this.state.form,
                            file: '',
                          },
                        });
                      }}
                    >
                      <img src={CloseIcon} />
                    </button>
                  </div>
                  <div className='text-center'>
                    <button className='btn btn-submit' onClick={() => this.submit()}>
                      Enviar
                    </button>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(ModalUpload);
